
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import ShareLink from './share-link'
import { SocialIconInstagram } from '../assets/assets';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "sharelink"
    }}>{`ShareLink`}</h1>
    <hr />
    <h2 {...{
      "id": "share-link"
    }}>{`Share Link`}</h2>
    <Playground __position={1} __code={'<ShareLink icon={<SocialIconInstagram />} href=\"https://www.economist.com\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ShareLink,
      SocialIconInstagram
    }} mdxType="Playground">
  <ShareLink icon={<SocialIconInstagram mdxType="SocialIconInstagram" />} href='https://www.economist.com' mdxType="ShareLink" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "share-link-inverse"
    }}>{`Share Link (inverse)`}</h2>
    <Playground __position={3} __code={'<ShareLink\n  inverse\n  icon={<SocialIconInstagram />}\n  href=\"https://www.economist.com\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ShareLink,
      SocialIconInstagram
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
  <ShareLink inverse icon={<SocialIconInstagram mdxType="SocialIconInstagram" />} href='https://www.economist.com' mdxType="ShareLink" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={ShareLink} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;